// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1yKfg","selects":"Documents_selects__3Kn-I"};